import axios, { type AxiosRequestConfig, type AxiosRequestHeaders } from 'axios'

// @ts-expect-error
const getBaseHeaders = (headers: AxiosRequestHeaders = {}) => {
  const authToken = localStorage.getItem('token')

  if (authToken) {
    return {
      ...headers,
      'X-Auth-Token': authToken,
    }
  }

  return headers
}

class Request {
  baseHeaders = getBaseHeaders()

  instance = axios.create({
    baseURL: import.meta.env.VITE_API_URL,
    headers: {
      ...getBaseHeaders(),
    },
  })

  get = async <T>(
    dest: string,
    params = {},
    config: Partial<AxiosRequestConfig> = {}
  ): Promise<T> => {
    const { data } = await this.instance.get<T>(dest, {
      ...config,
      // @ts-expect-error
      headers: getBaseHeaders(config.headers),
      params,
    })

    return data
  }

  delete = async <T>(
    dest: string,
    params = {},
    config: Partial<AxiosRequestConfig> = {}
  ): Promise<T> => {
    const { data } = await this.instance.delete<T>(dest, {
      ...config,
      // @ts-expect-error
      headers: getBaseHeaders(config.headers),
      params,
    })

    return data
  }

  post = async <T>(
    dest: string,
    body: Record<string, unknown>,
    params = {},
    config: Partial<AxiosRequestConfig> = {}
  ): Promise<T> => {
    const { data } = await this.instance.post<T>(dest, body, {
      ...config,
      // @ts-expect-error
      headers: getBaseHeaders(config.headers),
      params,
    })

    return data
  }

  put = async <T>(
    dest: string,
    body: Record<string, unknown>,
    params = {},
    config: Partial<AxiosRequestConfig> = {}
  ): Promise<T> => {
    const { data } = await this.instance.put<T>(dest, body, {
      ...config,
      // @ts-expect-error
      headers: getBaseHeaders(config.headers),
      params,
    })

    return data
  }

  patch = async <T>(
    dest: string,
    body: Record<string, unknown>,
    params = {},
    config: Partial<AxiosRequestConfig> = {}
  ): Promise<T> => {
    const { data } = await this.instance.patch<T>(dest, body, {
      ...config,
      // @ts-expect-error
      headers: getBaseHeaders(config.headers),
      params,
    })

    return data
  }

  multipart = async <T>(
    dest: string,
    formData: FormData,
    params = {},
    config: Partial<AxiosRequestConfig> = {}
  ): Promise<T> => {
    const { data } = await this.instance.post<T>(dest, formData, {
      ...config,
      params,
      // @ts-expect-error
      headers: getBaseHeaders({
        ...config.headers,
        'Content-Type': 'multipart/form-data',
      }),
    })

    return data
  }

  urlencoded = async <T>(
    dest: string,
    formData: FormData,
    params = {},
    config: Partial<AxiosRequestConfig> = {}
  ): Promise<T> => {
    const { data } = await this.instance.post<T>(dest, formData, {
      ...config,
      params,
      // @ts-expect-error
      headers: getBaseHeaders({
        ...config.headers,
        'Content-Type': 'application/x-www-form-urlencoded',
      }),
    })

    return data
  }
}

export default new Request()
